var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex align-center badge-box",class:_vm.status},[_vm._m(0),_c('div',{staticClass:"m-l-4",class:_vm.fontColor?'font-color':''},[_vm._v(" "+_vm._s(_vm.title)+" ")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"badge"},[_c('div',{staticClass:"after"})])
}]

export { render, staticRenderFns }